


























import Vue from "vue"
import type { AppUserSummary } from "@/datasource/appUsers"
import datasource from "@/datasource"

export default Vue.extend({
  props: {
    value: {
      type: [Object, Array],
      default: null,
    },

    returnId: {
      type: Boolean,
      default: false,
    },

    clearable: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      loading: true,
      appUsers: [] as AppUserSummary[],
    }
  },

  computed: {
    appUser: {
      get(): AppUserSummary {
        return this.value
      },

      set(value: AppUserSummary | AppUserSummary[] | string | string[]): void {
        this.$emit("input", value)
      },
    },
  },

  created() {
    this.loadData()
  },

  methods: {
    async loadData() {
      this.loading = true
      const result = await datasource.appUsers.listAppUserSummaries()
      if (result instanceof Error) {
        console.error(result)
        return
      } else {
        this.appUsers = result
        if (!this.clearable) {
          this.appUser ||= this.appUsers[0]
        }
      }
      this.loading = false
    },
  },
})
